import type { Engine } from "../../../engine/Engine";
import type { SugarModel } from "../../../loader/SugarModel";
import type { XzPoint } from "../../../shape/segment/types";
import type { DesignerObject } from "../object/DesignerObject";
import type { MeasurementApi } from "./MeasurementApi";
import { previewProductToPointer, type MeasurementSnap } from "./MeasurementSnapResolver";
import { MEASUREMENT_PREVIEW_EVENT } from "./MeasurementRenderer";

export class ProductMeasureSession {
  private _preview: MeasurementSnap | null = null;

  constructor(
    private readonly _source: SugarModel,
    private readonly _api: MeasurementApi,
    private readonly _engine: Engine,
  ) {}

  update(target: DesignerObject | null, pointer: XzPoint): MeasurementSnap | null {
    const snap = target?.measurementSnap?.(this._source, pointer) ?? null;
    this._preview = snap;
    this._engine.dispatchCustomEvent(MEASUREMENT_PREVIEW_EVENT, {
      detail: snap ?? previewProductToPointer(this._source, pointer),
    });
    return snap;
  }

  commit(): boolean {
    if (!this._preview) return false;
    this._api.create(this._preview);
    this.cancel();
    return true;
  }

  cancel(): void {
    this._preview = null;
    this._engine.dispatchCustomEvent(MEASUREMENT_PREVIEW_EVENT, {
      detail: null,
    });
  }
}
